// Typed helpers for in-app notifications and briefs (/api/notify). Pure URL builders.
import type { BriefView, NotificationView } from "@shared/api";
import { api } from "./api";

const enc = encodeURIComponent;

export const notifyUrls = {
  notifications: (unseenOnly: boolean) =>
    `/api/notify/notifications${unseenOnly ? "?unseen=1" : ""}`,
  seenAll: () => "/api/notify/notifications/seen-all",
  seen: (id: string) => `/api/notify/notifications/${enc(id)}/seen`,
  dismiss: (id: string) => `/api/notify/notifications/${enc(id)}/dismiss`,
  briefs: () => "/api/notify/briefs",
  brief: (id: string) => `/api/notify/briefs/${enc(id)}`,
  briefNow: () => "/api/notify/briefs/now",
  briefOpened: (id: string) => `/api/notify/briefs/${enc(id)}/opened`,
};

export const notifyApi = {
  notifications: (unseenOnly: boolean, signal?: AbortSignal) =>
    api<NotificationView[]>(notifyUrls.notifications(unseenOnly), { signal }),
  seenAll: () => api<{ seen: number }>(notifyUrls.seenAll(), { method: "POST" }),
  seen: (id: string) => api<NotificationView>(notifyUrls.seen(id), { method: "POST" }),
  dismiss: (id: string) => api<NotificationView>(notifyUrls.dismiss(id), { method: "POST" }),
  briefs: (signal?: AbortSignal) => api<BriefView[]>(notifyUrls.briefs(), { signal }),
  brief: (id: string, signal?: AbortSignal) => api<BriefView>(notifyUrls.brief(id), { signal }),
  briefNow: () => api<BriefView>(notifyUrls.briefNow(), { method: "POST" }),
  briefOpened: (id: string) => api<BriefView>(notifyUrls.briefOpened(id), { method: "POST" }),
};
